import styled from 'styled-components';
import { device, size } from '../../styles/devices';
import { COLORS } from '../../styles/variables';

export const RowContainer = styled.div`
  max-width: 871px;
  padding-left: 14px;
  margin: 0px auto 0px;
  @media ${device.tablet} {
    padding-left: 36px;
    margin-top: 12px;
  }
`;

export const DetailRow = styled.div`
  display: flex;
  justify-content: space-between;
  min-height: 61px;
  height: fit-content;
  max-width: 871px;
  margin: 0 auto;
  border-top: 1px solid ${COLORS.grey15};
  font-size: 13px;
  line-height: 24px;
  padding: 12px 0px 12px 18px;
  align-items: flex-end;
  &:first-child {
    border-top: none;
  }
  @media ${device.tablet} {
    padding-right: 24px;
    align-items: flex-start;
  }
`;

export const Price = styled.p`
  white-space: nowrap;
`;

export const Key = styled.p`
  margin-right: 50px;
  font-size: 16px;
  small {
    font-size: 13px;
  }
`;

export const Value = styled.p`
  font-weight: 400;
  white-space: nowrap;
  font-size: 16px;
`;

export const DrawerTitle = styled.p`
  color: ${COLORS.black};
  @media ${device.tablet} {
    color: ${COLORS.grey80};
  }
`;

export const DrawerCta = styled.button`
  background-color: transparent;
  border: none;
  margin-top: 10px;
  cursor: pointer;
  p {
    margin-right: 7px;
    display: inline-block;
    font-weight: 400;
    font-size: 12px;
    color: ${COLORS.grey60};
  }
  @media ${device.tablet} {
    position: absolute;
    top: 0;
    right: -22px;
    padding-left: 0;
    padding-right: 0;
    margin-top: 0;
  }
`;

export const DrawerCtaContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const CloseDrawerWrapper = styled.div`
  display: flex;
  padding-right: 0px;
  @media ${device.tablet} {
    padding-right: 24px;
  }
  justify-content: flex-end;
`;

export const DrawerRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 871px;
  margin: 0 auto;
  border: none;
  font-size: 16px;
  font-weight: 700;
  line-height: 21px;
  padding-left: 14px;
  @media ${device.tablet} {
    padding-left: 36px;
    padding-right: 24px;
  }
  min-height: 48px;
  height: fit-content;
  span {
    white-space: nowrap;
  }
  padding-top: 20px;
  align-items: flex-start;
`;
